import { ExternalLink } from 'lucide-react';
import React from 'react';
import { PageHeader } from '../../components/common/PageHeader';
import { MeasureMetrics } from '../metrics/tabs/MeasureMetrics';

export const MeasurePage: React.FC = () => {
  return (
    <section className="space-y-6">
      <PageHeader
        title="Measure"
        description="Ad reporting dashboards with attribution tracking across all channels"
        right={
          <a
            href="https://docs.embedreach.com/measure/introduction"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 transition-colors">
            API Docs
            <ExternalLink className="h-3.5 w-3.5" />
          </a>
        }
      />
      <MeasureMetrics />
    </section>
  );
};
